export const baseURL = "https://roulettecasino.butterlive.co.in/";
export const adminBaseURL = "https://admin.butterlive.co.in/";
export const key = "ZUH@eXb246w*n#FXe#TsMVCpikhEBgbk";
